import React from 'react'
import Layout from '../../components/corporateAdmin/Layout'
import { Helmet } from 'react-helmet'
import img from "../../assets/common.jpg"

function Common() {
    return (
        <div>
            <Layout>
                <Helmet>
                    <title>Admin - Staff</title>
                </Helmet>
                <img src={img} alt="logo" />
            </Layout>



        </div>
    )
}

export default Common
